export { default as Articles } from './Articles/Articles';
export { default as Cover } from './Cover/Cover';
export { default as LastArticles } from './LastArticles/LastArticles';
export { default as SearchBar } from './SearchBar/SearchBar';
export { default as Filter } from './Filter/Filter';
export { default as Details } from './Details/Details';
export { default as RelevantNews } from './RelevantNews/RelevantNews';
export { default as PaginationArticles } from './Pagination/Pagination';
